import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=a0d0f25e"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=a0d0f25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VMain,VRow})
